import React, { useContext, useState, useEffect } from "react"

import { ReactComponent as SelectIcon } from "../../../assets/images/select-icon.svg"
import MelodySelect from "../../../components/modal/melodySelect"
import Loading from "../../../components/loading/loading"
import Logs from "./Logs"
import Header from "../../../components/header/header"

import { StateContext } from "../../../context/StateContext"
import { MelodiesContext } from "../../../context/MelodiesContext"
import { TemplatesContext } from "../../../context/TemplatesContext"
import { getRealFlags } from "../../../utils/realFlags"

const PLACEHOLDER = { id: 0, title: "ВЫБЕРИТЕ ЗВОН" }

const Main = () => {
  const STATE = useContext(StateContext)
  const melodiesContext = useContext(MelodiesContext)
  const { templatesTitles } = useContext(TemplatesContext)

  const [currentMusicHex, setCurrentMusicHex] = useState("00")
  const [melody, setMelody] = useState("00")
  const [melodyState, setMelodyState] = useState(0)
  const [modalOpen, setModalOpen] = useState(false)
  const [templates] = useState(STATE.lastData.templates)
  const { is1Real } = getRealFlags(STATE.lastData)

  let melodies = []
  if (melodiesContext.melodies.length > 0) {
    melodies = [PLACEHOLDER].concat([...melodiesContext.melodies])
  }

  if (
    melodies
    && melodies.length > 0
    && templates
    && Object.keys(templatesTitles).length > 0
  ) {
    let lastId = melodies[melodies.length - 1].id

    templates.forEach(item => {
      melodies.push(
        {
          id: ++lastId,
          title: templatesTitles[item.id],
        }
      )
    })
  }

  const melodyTitle = melodiesContext.getTitle(melody, melodies)

  const save = () => {
    if (!is1Real) {
      return
    }

    if (melody !== "00") {
      if (currentMusicHex === "00") {
        STATE.sendData({ settings: { currentMusicHex: melody } })
      } else {
        STATE.sendData({ settings: { currentMusicHex: "00" } })
      }
    }
  }

  useEffect(() => {
    if (!!STATE.lastData) {
      console.log("Last data", STATE.lastData)

      setMelodyState(STATE.lastData.settings.currentMusicHEX !== "00")
      setCurrentMusicHex(STATE.lastData.settings.currentMusicHEX)

      if (STATE.lastData.settings.currentMusicHEX !== "00") {
        setMelody(STATE.lastData.settings.currentMusicHEX)
      }
    }
  }, [STATE.lastData])

  return (
    <div className="main-area-field full-height no-signal-area">
      <div className="main-area full-height">
        <div className="page-area center-h _signal no-p">
          <Header
            title={"Пульт"}
            backTitle={"Устройства"}
            backUrl={"/"}
          />

          <Logs />

          <div className="content options-bells">
            <div style={{ width: "100%" }}>
              <div
                role="button"
                tabIndex={0}
                className="input-link"
                onClick={() => setModalOpen(true)}
              >
                <div className="input-container _no-mr">
                  <div className="input-area">
                    <input
                      type="text"
                      readOnly
                      value={melodyTitle}
                      className="main-bell"
                    />
                  </div>

                  <SelectIcon className="select-icon _abs" />
                </div>
              </div>

              <MelodySelect
                isOpen={modalOpen}
                selected={melody}
                items={melodies}
                setModal={setModalOpen}
                setMelody={setMelody}
              />

              <div className="button-area">
                <button
                  className="btn btn-yellow"
                  disabled={!is1Real}
                  onClick={() => save()}
                >
                  {!STATE.isSending && !melodyState ? "Включить" : ""}
                  {!STATE.isSending && melodyState ? "Выключить" : ""}

                  {STATE.isSending && <Loading />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
